import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { uniqBy } from 'lodash';

import { allRecordsCql } from '@app/components';
import { axios } from '@app/utils';
import { DepartmentInstructorItemDto, SortDirection } from '@app/constants';

import { BrowseByField } from './constants';

export const useDepartmentsInstructorsFetch = (
  fieldName: BrowseByField
): UseQueryResult<DepartmentInstructorItemDto[]> => {
  return useQuery([`${fieldName}List`], () =>
    axios
      .get<Record<BrowseByField, DepartmentInstructorItemDto[]>>(
        `/opac-courses/${fieldName}`,
        {
          params: {
            limit: 1000,
            query: `${allRecordsCql} sortBy name/sort.${SortDirection.asc}`,
          },
        }
      )
      .then(response => uniqBy(response.data?.[fieldName], 'name'))
  );
};
